import { inject } from '@angular/core';
import { CanMatchFn, Route, UrlSegment } from '@angular/router';
import { UserService } from '../../infrastructure/shared/services/user.service';
import { canMatchRole } from './can-match-role';

export const CanMatchIndividual: CanMatchFn = (
  route: Route,
  segments: UrlSegment[],
) => {
  return canMatchRole(inject(UserService).isIndividual(), segments);
};
